import { useEffect, useRef } from "react";

// Adds `is-visible` to elements with class `reveal` when they enter the viewport.
export default function useReveal() {
    const rootRef = useRef(null);

    useEffect(() => {
        const root = rootRef.current || document;
        const targets = root.querySelectorAll(".reveal");
        if (!("IntersectionObserver" in window)) {
            targets.forEach((el) => el.classList.add("is-visible"));
            return;
        }
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
        );
        targets.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return rootRef;
}
